@if (showCarousel(); as carousel) {
    <div
        animate.enter="animate-fade-in-slower"
        aria-modal="true"
        cdkTrapFocus
        cdkTrapFocusAutoCapture
        class="fixed inset-0 z-50 flex size-full items-center justify-center bg-gallery-layer motion-reduce:animate-none"
        role="dialog"
        [attr.aria-label]="'CAROUSEL.ACCESSIBILITY.DIALOG_NAME' | translate"
        (animate.leave)="leave($event)"
    >
        <div class="relative h-5/6 w-2/3 overflow-hidden rounded-xl">
            @for (slide of carousel.slides; track $index) {
                <interacta-carousel-slide
                    class="absolute size-full transition-[translate] ease-in-out motion-reduce:transition-none"
                    [active]="currentIndex() === $index"
                    [attr.aria-hidden]="
                        currentIndex() !== $index ? 'true' : null
                    "
                    [attr.inert]="currentIndex() !== $index ? '' : null"
                    [class.z-10]="currentIndex() === $index"
                    [config]="carousel.config"
                    [index]="$index"
                    [ngClass]="
                        currentIndex() === $index
                            ? 'translate-x-0 duration-500'
                            : $index > currentIndex()
                              ? 'translate-x-[130%] delay-1000 duration-[0.1ms]'
                              : '-translate-x-[130%] delay-1000 duration-[0.1ms]'
                    "
                    [slide]="slide"
                    [totalItems]="carousel.slides.length"
                    (closeCarousel)="closeCarousel()"
                    (nextStep)="nextStep($event)"
                />
            }
        </div>
    </div>
}
